import React, { FC, FormEvent, forwardRef } from 'react';
import { DefaultLayoutPadding } from '../../../constants/Layout';
import theme from '../../../theme';
import { FlexContainer } from '../Container';
import { Error } from '../Text';
import { SelectElement } from './style';

export interface SelectProps {
  children: React.ReactNode;
  onChange: (e: FormEvent) => void;
  defaultValue?: string;
  name: string;
  fullWidth?: boolean;
  error?: string;
  [x: string]: any;
}

const Select: FC<SelectProps> = forwardRef(
  ({ children, onChange, name, error, defaultValue, fullWidth, value, ...rest }, ref) => {
    return (
      <FlexContainer style={{ position: 'relative' }} flexDirection="column">
        <Error style={{ position: 'absolute', top: '-18px', paddingLeft: theme.spacing[DefaultLayoutPadding] }}>
          {error}
        </Error>
        <SelectElement
          ref={ref}
          name={name}
          onChange={onChange}
          error={error}
          value={value ?? defaultValue}
          fullWidth={fullWidth}
          {...rest}
        >
          {children}
        </SelectElement>
      </FlexContainer>
    );
  }
);

Select.displayName = 'Select';
export default Select;
